import client from './client';

// spotifyUserId = reconectar una cuenta ya conectada (en vez de conectar una solicitud verificada).
export const getNonce = (requestId, spotifyUserId) =>
  client.post('/auth/nonce', { requestId, spotifyUserId }).then((r) => r.data.data.nonce);

export const getMySubscription = () =>
  client.get('/me/subscription').then((r) => r.data.data);

export const getMySpotifyAccounts = () =>
  client.get('/me/spotify-accounts').then((r) => r.data.data);

export const createSpotifyVerificationRequest = (email) =>
  client.post('/me/spotify-verification-requests', { email }).then((r) => r.data.data);

export const getMySpotifyVerificationRequests = () =>
  client.get('/me/spotify-verification-requests').then((r) => r.data.data);

export const updateSpotifyVerificationRequestEmail = (requestId, email) =>
  client.patch(`/me/spotify-verification-requests/${requestId}`, { email }).then((r) => r.data.data);

export const removeSpotifyAccount = (spotifyUserId) =>
  client.delete(`/auth/spotify/${spotifyUserId}`).then((r) => r.data);

export const getAccountConfig = (spotifyUserId) =>
  client.get(`/auth/spotify/${spotifyUserId}/config`).then((r) => r.data.data);

export const updateAccountConfig = (spotifyUserId, config) =>
  client.patch(`/auth/spotify/${spotifyUserId}/config`, config).then((r) => r.data);

export const getStaticQr = (spotifyUserId) =>
  client.get(`/auth/spotify/${spotifyUserId}/static-qr`).then((r) => r.data.data);

export const upsertStaticQr = (spotifyUserId, config) =>
  client.post(`/auth/spotify/${spotifyUserId}/static-qr`, config).then((r) => r.data.data);

export const dismissSpotifyVerificationRequest = (requestId) =>
  client.post(`/me/spotify-verification-requests/${requestId}/dismiss`).then((r) => r.data.data);

export const getSpotifyPlaylists = (spotifyUserId) =>
  client.get(`/auth/spotify/${spotifyUserId}/playlists`).then((r) => r.data.data);

export const setSpotifyPlaylist = (spotifyUserId, playlistId) =>
  client.put(`/auth/spotify/${spotifyUserId}/playlist`, { playlistId }).then((r) => r.data.data.playlist);
